import { render, staticRenderFns } from "./ArchivedTrips.vue?vue&type=template&id=3e079f05&scoped=true&"
import script from "./ArchivedTrips.vue?vue&type=script&lang=js&"
export * from "./ArchivedTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e079f05",
  null
  
)

export default component.exports